import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withKeys as _withKeys, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "default-activator-title noselect" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "gallery-header" }
const _hoisted_4 = { class: "gallery-title" }
const _hoisted_5 = { class: "gallery-content" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  class: "place-name noselect",
  style: {"color":"white"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['gallery-root', {'open': _ctx.open}])
  }, [
    _createElementVNode("div", {
      class: "just-holding-events",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.open = true)),
      onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.open = true), ["enter"])),
      tabindex: "0"
    }, [
      (!_ctx.open)
        ? _renderSlot(_ctx.$slots, "closed", { key: 0 }, () => [
            _createElementVNode("div", {
              class: "default-activator blurred",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.open = true)),
              onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.open = true), ["enter"]))
            }, [
              _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.closedText), 1),
              _createElementVNode("img", {
                class: "noselect",
                src: _ctx.places[_ctx.previewIndex] ? (_ctx.getImageset(_ctx.places[_ctx.previewIndex])?.get_thumbnailUrl() ?? '') : ''
              }, null, 8, _hoisted_2)
            ], 32)
          ])
        : _createCommentVNode("", true)
    ], 32),
    (_ctx.open)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          style: _normalizeStyle(_ctx.cssVars),
          class: "gallery blurred"
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.title), 1),
            (!_ctx.stayOpen)
              ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                  key: 0,
                  class: "gallery-close",
                  icon: "times",
                  size: "lg",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.open = false)),
                  onKeyup: _cache[5] || (_cache[5] = _withKeys(($event: any) => (_ctx.open = false), ["enter"])),
                  tabindex: "0"
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.places.entries(), ([index, place]) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: _normalizeClass(['gallery-item', {'selected': _ctx.highlightLastOnly ? _ctx.selectedPlace === place : _ctx.selectedPlaces.includes(place)}]),
                onClick: ($event: any) => (_ctx.selectPlace(place))
              }, [
                _createElementVNode("img", {
                  class: "noselect mobile-off",
                  src: _ctx.getImageset(place)?.get_thumbnailUrl() ?? ''
                }, null, 8, _hoisted_7),
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.altLabels.length == 0 ? place?.get_name() : _ctx.altLabels[index]), 1)
              ], 10, _hoisted_6))
            }), 128))
          ]),
          (_ctx.open)
            ? _renderSlot(_ctx.$slots, "default", { key: 0 })
            : _createCommentVNode("", true)
        ], 4))
      : _createCommentVNode("", true)
  ], 2))
}